// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__amvh0","searchInput":"Input_searchInput__2I84u","otpWrapper":"Input_otpWrapper__I3bfk"};